import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tripStatusPipe'
})
export class TripStatusPipePipe implements PipeTransform {

  transform(value: any) {
    if(value=="0"){
      return "Not Satrted"
    }
      else if (value=="1"){
        return "Started"
      }
      else if (value=="2"){
        return "Completed"
      }

    }
    

}
